export default "__VITE_ASSET__LIy$MVuV__"